import { FormattedMessage } from 'react-intl';
import React from 'react';

export const Multiple = () => <FormattedMessage defaultMessage='(Multiple)' description='gridText.multiple' id='mAIWNR' />;
